/* eslint-disable */

let _localize = function localize (contentDict, language, path, args) {
  let argsType = typeof args
  if (argsType === 'number') {
    if (args === 1) {
      path = path + '_singular'
    } else {
      path = path + '_plural'
    }
  }
  // language is fixed in config, but user-overridable

  let contentLocal = contentDict
  if (!contentLocal) {
    return `Localization('${path}')`
  }
  let obj = contentLocal[language]

  let [found, localized] = findInObject(obj, path)
  if (!found) {
    return `Localization('${path}')`
  }

  let regex = /\{\{(\w+)\}\}/g

  let matches
  while ((matches = regex.exec(localized))) {
    if (argsType === 'number' && matches[1] === 'count') {
      // special case, this is singular/plural
      localized = localized.replace('{{count}}', args)
    } else if (argsType === 'object' && args.hasOwnProperty(matches[1])) {
      let replacement = args[matches[1]]

      // if the replacement is a numbro.js instance, format the currency value
      if (typeof replacement === 'object' &&
        replacement.hasOwnProperty('_value')) {
        replacement = fnCurrencyFormat(replacement)
      }
      localized = localized.replace(matches[0], replacement)
    }
  }
  return localized
}

let fnCurrencyFormat = function currencyFormat (value) {
  return value.format('$0.00')
}

function findInObject (obj, path) {
  let parts = path.split('.')

  while (parts.length) {
    let sub = parts.shift()
    if (obj===null || typeof obj === 'undefined' || typeof obj[sub] === 'undefined') {
      return [false, void 0]
    }
    obj = obj[sub]
  }

  return [true, obj]
}

export { _localize, findInObject }
